<template>
    <section>
      <b-container>
        <b-row align-v="center" class="row-grid">
          <b-col md="6" class="order-md-2">
            <b-img src="img/custom/mumm_sm.png" fluid />
          </b-col>
          <b-col md="6" class="order-md-1">
            <div class="pr-md-5">
                <h1>
                            Dear Artist, before we start with your application, please choose the book format you’re interested in: A4 or 30x30
                        </h1>
                        <b-form-radio-group v-model="currentSnapWizard.format">
                        <div>
                            <b-form-radio value="a4" name="unchecked" class="mb-3">
                                A4 (21x29.7 cm / 11.69 x 8.27 inches)

                            </b-form-radio>
                        </div>
                        <div>
                            <b-form-radio value="30x30" name="checked" class="mb-3">
                                30x30 (30x30 cm / 11.81 x 11.81 Inches)
                            </b-form-radio>
                        </div>
                    </b-form-radio-group>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

  

</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'

export default {
    name: 'snap01_format',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
            if (
                this.currentSnapWizard.format != '' && this.currentSnapWizard.format != 'null' && typeof this.currentSnapWizard.format != "undefined"
            ) {
                //this.claim.allValidated = true;
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.$emit('showFooterNav');
                return true;
            }
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            return false;
        },
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
        show_images_hint() {
            if(this.currentSnapWizard.images_ready == 1 || this.currentSnapWizard.images_ready == undefined){
                return true;
            }
            else{
                return false;
            }
        },
        show_sorry() {
            if(this.currentSnapWizard.images_ready == 0 || this.currentSnapWizard.images_ready == "" ){
                return true;
            }
            else{
                return false;
            }
        },
    },
    watch: {
        currentSnapWizard: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                this.allDataValidated();
            },
            deep: true
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.$emit('hideFooterNav');

        console.log("STep FORMAT:" +this.currentSnapWizard.format);
        this.allDataValidated();
    }
};
</script>